"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 34C23.5228 34 28 29.5228 28 24C28 18.4772 23.5228 14 18 14C12.4772 14 8 18.4772 8 24C8 29.5228 12.4772 34 18 34Z",
        stroke: "currentColor",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 26C19.1046 26 20 25.1046 20 24C20 22.8954 19.1046 22 18 22C16.8954 22 16 22.8954 16 24C16 25.1046 16.8954 26 18 26Z",
        stroke: "currentColor",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "34.5",
        y: "16.1667",
        width: "15",
        height: "3",
        rx: "0.5",
        stroke: "currentColor"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          x: "34.5",
          y: "22.8333",
          width: "5",
          height: "3",
          rx: "0.5",
          stroke: "currentColor"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          x: "42.5",
          y: "22.8333",
          width: "7",
          height: "3",
          rx: "0.5",
          stroke: "currentColor"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "34.5",
        y: "29.5",
        width: "11",
        height: "3",
        rx: "0.5",
        stroke: "currentColor"
      })]
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    x: "3",
    y: "7",
    width: "50",
    height: "34",
    rx: "2",
    stroke: "currentColor",
    strokeWidth: "4",
    fill: "none"
  })]
}), '0 0 56 48');